import { render, staticRenderFns } from "./SettlementSummary.vue?vue&type=template&id=6dd29c2b"
import script from "./SettlementSummary.vue?vue&type=script&lang=js"
export * from "./SettlementSummary.vue?vue&type=script&lang=js"
import style0 from "./SettlementSummary.vue?vue&type=style&index=0&id=6dd29c2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports